export default "__VITE_ASSET__BBjp$QO5__"